module.exports = __webpack_public_path__ + "img/caselist11.b05f2ec5.jpg";